<template>
  <el-drawer :visible.sync="currentValue" class="project-news-dialog" :modal="false">
    <div class="project-news-dialog-header">
      <div class="project-news-dialog-header_left">
        <i class="iconfont iconicon_trends"></i>
        <span>项目动态</span>
      </div>
      <i class="iconfont iconicon_develop activeIconHover project-news-dialog-header_right" @click="currentValue = false"></i>
    </div>
    <dynamic reference v-if="currentValue"></dynamic>
  </el-drawer>
</template>

<script>
import dynamic from '@/views/dynamic/index.vue'

export default {
  components: {
    dynamic
  },
  props: ['value'],
  computed: {
    currentValue: {
      get: function () {
        return this.value || undefined;
      },
      set: function (newValue) {
        this.$emit('input', newValue || null)
      }
    },
    computedDataList() {
      return this.groupData(this.dataList);
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    openView() {
      // this.init()
    }
  }
}
</script>

<style lang="scss">
.project-news-dialog {
  .el-drawer__header {
    display: none;
  }
  .el-drawer {
    width: 580px !important;
  }
  .el-drawer__body {
    padding: 0 !important;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  #el-drawer__title {
    display: none;
  }
  .nothing-box .tip {
    margin-bottom: 0;
  }
  .project-news-dialog-header {
    width: 100%;
    height: 54px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px;
    box-sizing: border-box;
    border-top: 1px solid rgba(231, 232, 237, 0.6);
    flex-shrink: 0;
    .project-news-dialog-header_left {
      font-size: 16px;
      font-weight: bold;
      i {
        font-weight: 400;
        color: #2682FF;
        margin-right: 10px;
      }
    }
    .project-news-dialog-header_right {
      transform: rotate(180deg);
      color: rgba(32, 32, 32, 0.6);
    }
  }
  .dynamic-content {
    padding: 0 0 0 24px;
    height: 0;
    flex: 1;
    box-sizing: border-box;
    .el-card {
      &::-webkit-scrollbar-track-piece {
        background-color: #ECEDF0;
      }
      &::-webkit-scrollbar {
        width: 6px;
        height: 8px;
        background-color: transparent;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 0;
        background-color: #C8CBD3;
        &:active, &:hover {
          background-color: #9199A7;
        }
      }
    }
    .search-box {
      display: none;
    }
    .el-timeline-item {
      padding-right: 0;
      margin-bottom: 22px;
    }
    .el-timeline-item__content {
      margin-right: 0;

      .dynamic-log {
        padding: 0;
      }
      .message-model {
        flex: 1;
        width: 0;
      }
      .message-line-box {
        flex-wrap: wrap;
      }
    }
    .el-timeline-item__content-res {
      &::after {
        display: none;
      }
    }
  }
}
</style>
